/* ============================================================
   product-gallery.js — Swiss PDP galerisi (CANLI sistemle BİREBİR)
   ------------------------------------------------------------
   Kaynak: audit/old-pdp/sections__product-swiss-grid.liquid (~1929-2012)

   Mobil  (<1024px): native scroll-snap track + dots + counter.
                     scroll → aktif index, dot click → scrollTo.
   Desktop (≥1024px): JS .sg-thumbs rail'ini KURAR (her slide için 48px thumb),
                      thumb click → goToSlide(i): o slide .sg-active olur
                      (tek ana görsel görünür), diğerleri display:none.
                      resize'da kur/yık (initDesktopThumbs/teardownDesktopThumbs).

   Vanilla. jQuery/Flickity/PhotoSwipe YOK.
   Opsiyonel lightbox: window.__lightbox varsa zoom görsele tıkla → açar
   (yoksa sessizce atlanır — canlı sistemi bozmaz).
   ============================================================ */
(function () {
  'use strict';

  var gallery = document.querySelector('[data-pdp-gallery]');
  if (!gallery) return;

  var track = gallery.querySelector('[data-gallery-track]');
  if (!track) return;

  var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dots] .gallery-dot'));
  var counter = gallery.querySelector('[data-gallery-current]');
  var desktopMql = window.matchMedia('(min-width: 1024px)');
  var isDesktop = function () { return desktopMql.matches; };

  var currentSlide = 0;
  var scrollTimer = null;

  var heroEl = track.querySelector('.gallery-hero');
  var slideEls = Array.prototype.slice.call(track.querySelectorAll('.gallery-slide'));
  var allSlides = heroEl ? [heroEl].concat(slideEls) : slideEls;
  var mthumbs = []; /* mobil kare thumbnail butonları (nokta yerine) */

  /* Thumbnail için DAİMA küçük görsel iste (perf): width param'ı varsa 160'a
     düşür, yoksa ekle. Tam boy (900px+) hero görselini thumb'a yükleme. */
  function thumbSrc(src) {
    if (!src) return src;
    if (/[?&]width=/.test(src)) return src.replace(/([?&]width=)\d+/, '$1160');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function goToSlide(idx) {
    if (idx < 0 || idx >= allSlides.length) return;
    currentSlide = idx;
    dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    if (counter) counter.textContent = idx + 1;
    /* Mobil thumbnail senkronu: aktif kareyi işaretle + ortala */
    mthumbs.forEach(function (t) {
      t.classList.toggle('active', parseInt(t.getAttribute('data-mindex'), 10) === idx);
    });
    if (!isDesktop()) centerMobileThumb(idx);
    if (isDesktop()) {
      allSlides.forEach(function (s, i) { s.classList.toggle('sg-active', i === idx); });
      var ths = gallery.querySelectorAll('.sg-thumb');
      Array.prototype.forEach.call(ths, function (t, i) { t.classList.toggle('active', i === idx); });
    }
    /* Katman slide'ına gelince hotspot'ları reveal et (animasyon bir kez oynar) */
    var activeSlide = allSlides[idx];
    if (activeSlide && activeSlide.querySelector) {
      var av = activeSlide.querySelector('.pl__visual');
      if (av) av.classList.add('pl--hotspots-revealed');
    }
  }

  /* Desktop: thumb rail kur + ilk slide'ı göster */
  function initDesktopThumbs() {
    if (!allSlides.length) return;
    var container = gallery.querySelector('.sg-thumbs');
    if (!container) {
      container = document.createElement('div');
      container.className = 'sg-thumbs';
      allSlides.forEach(function (slide, i) {
        var img = slide.querySelector('img');
        if (!img) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sg-thumb' + (i === 0 ? ' active' : '');
        var thumbImg = document.createElement('img');
        thumbImg.src = thumbSrc(img.src);
        thumbImg.alt = img.alt || '';
        thumbImg.width = 48;
        thumbImg.height = 48;
        thumbImg.loading = 'lazy';
        thumbImg.decoding = 'async';
        btn.appendChild(thumbImg);
        btn.addEventListener('click', function () { goToSlide(i); });
        container.appendChild(btn);
      });
      gallery.insertBefore(container, track);
    }
    /* Her zaman aktif slide'ı garanti et */
    var hasActive = allSlides.some(function (s) { return s.classList.contains('sg-active'); });
    if (!hasActive) {
      allSlides.forEach(function (s, i) { s.classList.toggle('sg-active', i === currentSlide); });
    }
  }

  function teardownDesktopThumbs() {
    var container = gallery.querySelector('.sg-thumbs');
    if (container) container.remove();
    allSlides.forEach(function (s) { s.classList.remove('sg-active'); });
  }

  /* Mobil: görselin altına kare thumbnail şeridi kur (nokta yerine).
     Bir kez kurulur, CSS ile yalnız mobilde görünür (desktop sol sidebar ayrı).
     Imgsiz slayt (video) atlanır — index korunur, swipe ile erişilir. */
  function buildMobileThumbs() {
    if (allSlides.length < 2) return;
    if (gallery.querySelector('.gallery-mthumbs')) return;
    var rail = document.createElement('div');
    rail.className = 'gallery-mthumbs';
    rail.setAttribute('data-gallery-mthumbs', '');
    allSlides.forEach(function (slide, i) {
      var img = slide.querySelector('img');
      if (!img) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gallery-mthumb' + (i === currentSlide ? ' active' : '');
      btn.setAttribute('data-mindex', i);
      btn.setAttribute('aria-label', 'Görsel ' + (i + 1));
      var im = document.createElement('img');
      im.src = img.src.replace(/width=\d+/, 'width=160');
      im.alt = '';
      im.width = 52; im.height = 52;
      im.loading = 'lazy'; im.decoding = 'async';
      btn.appendChild(im);
      btn.addEventListener('click', function () {
        track.scrollTo({ left: i * track.offsetWidth, behavior: 'smooth' });
        goToSlide(i);
      });
      rail.appendChild(btn);
      mthumbs.push(btn);
    });
    gallery.appendChild(rail);
  }

  /* Aktif thumbnail'ı şeridin ortasına kaydır (sığarsa zaten ortalı durur) */
  function centerMobileThumb(idx) {
    var rail = gallery.querySelector('.gallery-mthumbs');
    if (!rail) return;
    var btn = rail.querySelector('[data-mindex="' + idx + '"]');
    if (!btn) return;
    var target = btn.offsetLeft - (rail.clientWidth - btn.offsetWidth) / 2;
    rail.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
  }

  function handleBreakpointChange() {
    if (isDesktop()) { initDesktopThumbs(); }
    else { teardownDesktopThumbs(); }
  }
  buildMobileThumbs();
  handleBreakpointChange();
  if (desktopMql.addEventListener) {
    desktopMql.addEventListener('change', handleBreakpointChange);
  } else if (desktopMql.addListener) {
    desktopMql.addListener(handleBreakpointChange);
  }

  /* Mobil: scroll tracking → aktif slayt + thumbnail senkronu (swipe ilerletir) */
  if (allSlides.length > 1) {
    track.addEventListener('scroll', function () {
      if (isDesktop()) return;
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var w = track.offsetWidth;
        if (!w) return;
        var idx = Math.round(track.scrollLeft / w);
        if (idx !== currentSlide) goToSlide(idx);
      }, 50);
    }, { passive: true });
  }

  /* Mobil yatay SWIPE → slayt değiştir. pan-y native yatay scroll'u kapatıyor (galeri
     touch'ta kendi başına oynamaz, dikey parmak SAYFAYI scroll eder). Yatay swipe'ı
     biz JS ile algılayıp programmatic scrollTo yapıyoruz (touch-action'dan etkilenmez).
     Listener'lar passive → dikey scroll ASLA engellenmez. */
  (function () {
    var sx = 0, sy = 0, tracking = false;
    track.addEventListener('touchstart', function (e) {
      if (isDesktop() || !e.touches[0]) { tracking = false; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (!tracking || isDesktop() || !e.changedTouches[0]) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        var next = dx < 0 ? currentSlide + 1 : currentSlide - 1;
        if (next >= 0 && next < allSlides.length) {
          track.scrollTo({ left: next * track.offsetWidth, behavior: 'smooth' });
        }
      }
    }, { passive: true });
  })();

  /* Opsiyonel lightbox — yalnızca window.__lightbox mevcutsa.
     Canlı Swiss sisteminde yoktu; varsa zoom imkânı ekler, yoksa hiçbir şey yapmaz.
     Gift overlay (data-gift-modal) ayrı buton → lightbox tetiklemez. */
  function collectSources() {
    return allSlides.map(function (s) {
      var img = s.querySelector('img');
      if (!img) return null;
      return img.getAttribute('data-zoom-src') || img.currentSrc || img.src;
    }).filter(Boolean);
  }
  allSlides.forEach(function (s, i) {
    var img = s.querySelector('img');
    if (!img) return;
    img.addEventListener('click', function () {
      if (!window.__lightbox || typeof window.__lightbox.open !== 'function') return;
      window.__lightbox.open(collectSources(), i);
    });
  });

  /* ── Ürün-çekimi spec pin'leri (son 3 slide) — additive, katman mantığından BAĞIMSIZ.
     Normal: tıkla-aç. ?layer_debug → sürükle-konumla + "config KOPYALA" çıktısı. ── */
  var pinGroupEls = Array.prototype.slice.call(gallery.querySelectorAll('.gallery-slide-pins'));
  if (pinGroupEls.length) {
    var PIN_DIRS = ['right', 'left', 'above', 'below'];
    var pinDebug = /[?&]layer_debug/.test(location.search) || (window.Shopify && window.Shopify.designMode);
    var pinMobile = window.matchMedia('(max-width: 749px)');
    var setPinDir = function (c, dir) {
      PIN_DIRS.forEach(function (d) { c.classList.remove('plh__callout--label-' + d); });
      c.classList.add('plh__callout--label-' + dir); c.dataset.dir = dir;
    };
    var eachPin = function (fn) {
      pinGroupEls.forEach(function (grp) {
        Array.prototype.slice.call(grp.querySelectorAll('.plh__callout')).forEach(function (c) { fn(c, grp); });
      });
    };

    if (!pinDebug) {
      var allPins = [];
      eachPin(function (callout) {
        allPins.push(callout);
        var trigger = callout.querySelector('.plh__trigger');
        if (!trigger) return;
        trigger.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var isOpen = callout.classList.contains('is-open');
          allPins.forEach(function (c) {
            c.classList.remove('is-open');
            var t = c.querySelector('.plh__trigger'); if (t) t.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) { callout.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
        });
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.gallery-slide-pins')) allPins.forEach(function (c) { c.classList.remove('is-open'); });
      });
    } else {
      /* DEBUG: ürün pin'lerini sürükle (mobilde --mx/--my, desktop --x/--y, çift-tap=yön).
         Pozisyon her pin'in KENDİ slide kapsamına (.gallery-slide-pins) göre. */
      pinGroupEls.forEach(function (g) { g.classList.add('pl--debug'); });
      var pinBar = document.createElement('div');
      pinBar.style.cssText = 'position:fixed;bottom:0;left:0;right:0;z-index:100001;background:rgba(8,10,16,.96);color:#fff;font:600 11px/1.4 ui-monospace,monospace;padding:8px 10px;display:flex;gap:8px;align-items:flex-start;flex-wrap:wrap;max-height:44vh;overflow:auto;-webkit-overflow-scrolling:touch;';
      pinBar.innerHTML = '<button type="button" data-copy style="flex:0 0 auto;background:#4ade80;color:#053;border:0;border-radius:4px;padding:6px 10px;font-weight:800;cursor:pointer;">PIN config KOPYALA</button><span data-out style="white-space:pre-wrap;word-break:break-word;"></span>';
      document.body.appendChild(pinBar);
      var pinOut = pinBar.querySelector('[data-out]');
      var txt = function (el, sel) { var n = el.querySelector(sel); return n ? n.textContent.trim() : ''; };
      var pinPos = function (c) {
        var s = getComputedStyle(c);
        return {
          x: +(parseFloat(s.getPropertyValue('--x')) || 0).toFixed(1), y: +(parseFloat(s.getPropertyValue('--y')) || 0).toFixed(1),
          mx: +(parseFloat(s.getPropertyValue('--mx')) || 0).toFixed(1), my: +(parseFloat(s.getPropertyValue('--my')) || 0).toFixed(1)
        };
      };
      var buildConfig = function () {
        return pinGroupEls.map(function (grp) {
          return Array.prototype.slice.call(grp.querySelectorAll('.plh__callout')).map(function (c) {
            var p = pinPos(c);
            return [c.dataset.layerId, c.dataset.dir || 'below', p.x, p.y, p.mx, p.my, txt(c, '.plh__short'), txt(c, '.plh__label span')].join('|');
          }).join(';;');
        }).join('###');
      };
      var renderPinBar = function () { pinOut.textContent = buildConfig(); };
      pinBar.querySelector('[data-copy]').addEventListener('click', function () {
        var s = buildConfig();
        if (navigator.clipboard) { navigator.clipboard.writeText(s).catch(function () {}); }
        pinOut.textContent = s;
      });
      eachPin(function (callout, grp) {
        var trigger = callout.querySelector('.plh__trigger');
        if (!trigger) return;
        trigger.draggable = false;
        trigger.addEventListener('dragstart', function (e) { e.preventDefault(); });
        var inDrag = false, lastTap = 0;
        function begin(e, pt) {
          if (inDrag) return; inDrag = true; e.preventDefault(); e.stopPropagation();
          callout.classList.add('is-dragging');
          var sx = pt.clientX, sy = pt.clientY, didDrag = false;
          function moveTo(p) {
            if (Math.abs(p.clientX - sx) > 4 || Math.abs(p.clientY - sy) > 4) didDrag = true;
            var rect = grp.getBoundingClientRect(), mob = pinMobile.matches;
            var px = +Math.max(0, Math.min(100, ((p.clientX - rect.left) / rect.width) * 100)).toFixed(1);
            var py = +Math.max(0, Math.min(100, ((p.clientY - rect.top) / rect.height) * 100)).toFixed(1);
            callout.style.setProperty(mob ? '--mx' : '--x', px + '%');
            callout.style.setProperty(mob ? '--my' : '--y', py + '%');
            renderPinBar();
          }
          function onPM(me) { me.preventDefault(); moveTo(me); }
          function onTM(me) { var t = me.touches && me.touches[0]; if (!t) return; me.preventDefault(); moveTo(t); }
          function dn() {
            inDrag = false; callout.classList.remove('is-dragging');
            document.removeEventListener('pointermove', onPM); document.removeEventListener('pointerup', dn);
            document.removeEventListener('touchmove', onTM); document.removeEventListener('touchend', dn);
            document.removeEventListener('mousemove', onPM); document.removeEventListener('mouseup', dn);
            if (!didDrag) {
              var now = +new Date();
              if (now - lastTap < 380) { var i = PIN_DIRS.indexOf(callout.dataset.dir || 'below'); setPinDir(callout, PIN_DIRS[(i + 1) % PIN_DIRS.length]); renderPinBar(); }
              lastTap = now;
            }
          }
          if (e.type === 'pointerdown') { document.addEventListener('pointermove', onPM, { passive: false }); document.addEventListener('pointerup', dn, { once: true }); }
          else if (e.type === 'touchstart') { document.addEventListener('touchmove', onTM, { passive: false }); document.addEventListener('touchend', dn, { once: true }); }
          else { document.addEventListener('mousemove', onPM); document.addEventListener('mouseup', dn, { once: true }); }
          moveTo(pt);
        }
        trigger.addEventListener('pointerdown', function (e) { begin(e, e); });
        trigger.addEventListener('mousedown', function (e) { if (e.button === 0) begin(e, e); });
        trigger.addEventListener('touchstart', function (e) { var t = e.touches && e.touches[0]; if (t) begin(e, t); }, { passive: false });
      });
      renderPinBar();
    }
  }

  /* ── Katman paneli hotspot'ları (galeri 2. slide) ──
     Normal: tıkla-aç/kapa. ?layer_debug → sürükle-konumla (mobil --mx/--my) + koordinat barı.
     Section'ın inline JS'i kendi .pl__visual'ini bağlar; bu blok GALERİ kopyasını bağlar. */
  var layerVisual = gallery.querySelector('.pl__visual');
  if (layerVisual) {
    var layerCallouts = Array.prototype.slice.call(layerVisual.querySelectorAll('.plh__callout[data-layer-id]'));
    var DIRS = ['right', 'left', 'above', 'below'];
    var layerDebug = /[?&]layer_debug/.test(location.search) || (window.Shopify && window.Shopify.designMode);

    function setDir(callout, dir) {
      DIRS.forEach(function (d) { callout.classList.remove('plh__callout--label-' + d); });
      callout.classList.add('plh__callout--label-' + dir);
      callout.dataset.dir = dir;
    }

    if (!layerDebug) {
      /* NORMAL mod: tıkla-aç/kapa + dışarı-kapat */
      var closeLayers = function (except) {
        layerCallouts.forEach(function (c) {
          if (c === except) return;
          c.classList.remove('is-open');
          var t = c.querySelector('.plh__trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      };
      layerCallouts.forEach(function (callout) {
        var trigger = callout.querySelector('.plh__trigger');
        if (!trigger) return;
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var isOpen = callout.classList.contains('is-open');
          closeLayers(callout);
          if (isOpen) {
            callout.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
          } else {
            callout.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          }
        });
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.pl__visual')) closeLayers(null);
      });
    } else {
      /* DEBUG mod: sürükle-konumla. Mobil ekranda --mx/--my, desktop --x/--y. Çift-tap = yön. */
      var mobileQuery = window.matchMedia('(max-width: 749px)');
      var dbgImg = layerVisual.querySelector('.pl__visual-img');
      var mk = (((dbgImg && dbgImg.src) || '').match(/v[123]/) || ['v2'])[0];
      var storageKey = 'muyu-gallery-layer-positions:' + mk;
      var stored = {};
      try { stored = JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch (e) {}

      layerVisual.classList.add('pl--hotspots-revealed', 'pl--debug');

      var bar = document.createElement('div');
      bar.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:100000;background:rgba(10,10,12,.93);color:#fff;font:600 11px/1.45 ui-monospace,monospace;padding:8px 10px;display:flex;gap:10px;align-items:flex-start;flex-wrap:wrap;max-height:42vh;overflow:auto;-webkit-overflow-scrolling:touch;';
      bar.innerHTML = '<button type="button" style="flex:0 0 auto;background:#fff;color:#111;border:0;border-radius:4px;padding:4px 8px;font-weight:700;cursor:pointer;">GALERİ Reset</button><span style="white-space:pre-wrap;word-break:break-word;"></span>';
      document.body.appendChild(bar);
      var resetBtn = bar.querySelector('button');
      var barText = bar.querySelector('span');

      function readPos(callout) {
        var s = getComputedStyle(callout);
        var mob = mobileQuery.matches;
        var x = parseFloat(s.getPropertyValue(mob ? '--mx' : '--x')) || 0;
        var y = parseFloat(s.getPropertyValue(mob ? '--my' : '--y')) || 0;
        return { x: +x.toFixed(1), y: +y.toFixed(1), dir: callout.dataset.dir || 'right' };
      }
      function renderBar() {
        barText.textContent = layerCallouts.map(function (c) {
          var p = readPos(c);
          return c.dataset.layerId + ':' + p.x + ',' + p.y + ',' + p.dir;
        }).join('  ·  ');
      }
      function writePos(callout, x, y) {
        var mob = mobileQuery.matches;
        var rx = +Math.max(0, Math.min(100, x)).toFixed(1);
        var ry = +Math.max(0, Math.min(100, y)).toFixed(1);
        callout.style.setProperty(mob ? '--mx' : '--x', rx + '%');
        callout.style.setProperty(mob ? '--my' : '--y', ry + '%');
        var id = callout.dataset.layerId;
        stored[id] = stored[id] || {};
        stored[id][mob ? 'mx' : 'x'] = rx;
        stored[id][mob ? 'my' : 'y'] = ry;
        stored[id].dir = callout.dataset.dir || 'right';
        try { localStorage.setItem(storageKey, JSON.stringify(stored)); } catch (e) {}
        renderBar();
      }

      /* Kayıtlıları uygula (reload kalıcılığı) */
      layerCallouts.forEach(function (callout) {
        var saved = stored[callout.dataset.layerId];
        if (!saved) return;
        var mob = mobileQuery.matches;
        var sx = mob ? saved.mx : saved.x, sy = mob ? saved.my : saved.y;
        if (sx != null) callout.style.setProperty(mob ? '--mx' : '--x', sx + '%');
        if (sy != null) callout.style.setProperty(mob ? '--my' : '--y', sy + '%');
        if (saved.dir) setDir(callout, saved.dir);
      });

      layerCallouts.forEach(function (callout) {
        var trigger = callout.querySelector('.plh__trigger');
        if (!trigger) return;
        var inDrag = false, lastTap = 0;
        trigger.draggable = false;
        trigger.addEventListener('dragstart', function (e) { e.preventDefault(); });

        function begin(e, pt) {
          if (inDrag) return;
          inDrag = true;
          e.preventDefault();
          e.stopPropagation();
          callout.classList.add('is-dragging');
          var startX = pt.clientX, startY = pt.clientY, didDrag = false;
          function moveTo(p) {
            if (Math.abs(p.clientX - startX) > 4 || Math.abs(p.clientY - startY) > 4) didDrag = true;
            var rect = layerVisual.getBoundingClientRect();
            writePos(callout, ((p.clientX - rect.left) / rect.width) * 100, ((p.clientY - rect.top) / rect.height) * 100);
          }
          function onPM(me) { me.preventDefault(); moveTo(me); }
          function onTM(me) { var t = me.touches && me.touches[0]; if (!t) return; me.preventDefault(); moveTo(t); }
          function done() {
            inDrag = false;
            callout.classList.remove('is-dragging');
            document.removeEventListener('pointermove', onPM);
            document.removeEventListener('pointerup', done);
            document.removeEventListener('touchmove', onTM);
            document.removeEventListener('touchend', done);
            document.removeEventListener('mousemove', onPM);
            document.removeEventListener('mouseup', done);
            if (!didDrag) {
              var now = +new Date();
              if (now - lastTap < 380) {
                var i = DIRS.indexOf(callout.dataset.dir || 'right');
                setDir(callout, DIRS[(i + 1) % DIRS.length]);
                var p = readPos(callout);
                writePos(callout, p.x, p.y);
              }
              lastTap = now;
            }
          }
          if (e.type === 'pointerdown') {
            document.addEventListener('pointermove', onPM, { passive: false });
            document.addEventListener('pointerup', done, { once: true });
          } else if (e.type === 'touchstart') {
            document.addEventListener('touchmove', onTM, { passive: false });
            document.addEventListener('touchend', done, { once: true });
          } else {
            document.addEventListener('mousemove', onPM);
            document.addEventListener('mouseup', done, { once: true });
          }
          moveTo(pt);
        }
        trigger.addEventListener('pointerdown', function (e) { begin(e, e); });
        trigger.addEventListener('mousedown', function (e) { if (e.button === 0) begin(e, e); });
        trigger.addEventListener('touchstart', function (e) { var t = e.touches && e.touches[0]; if (t) begin(e, t); }, { passive: false });
      });

      resetBtn.addEventListener('click', function () {
        try { localStorage.removeItem(storageKey); } catch (e) {}
        location.reload();
      });
      renderBar();
    }
  }
})();

/* ============================================================
   Kampanya geri sayım — flip-card (hero overlay)
   ------------------------------------------------------------
   Her gece İstanbul 00:00'a EVERGREEN sayar, gece yarısında otomatik
   23:59:59'a sıfırlanır (sabit deadline yok → "bugün bitiyor" gerçek).
   İstanbul UTC+3 sabit (Türkiye'de DST yok) → ziyaretçi saat diliminden
   bağımsız, mağaza günüyle hizalı (veri doğruluğu).
   Hane değişince .is-flip ile flip animasyonu; reduced-motion'da düz değişir.
   Self-contained: galeri JS'inden bağımsız, [data-gallery-countdown] yoksa çıkar.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-gallery-countdown]');
  if (!root) return;

  var IST_OFFSET = 3 * 3600 * 1000; /* İstanbul UTC+3, kalıcı (DST yok) */
  var DAY = 86400000;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var cells = {};
  ['h0', 'h1', 'm0', 'm1', 's0', 's1'].forEach(function (k) {
    cells[k] = root.querySelector('[data-cd="' + k + '"]');
  });

  function setDigit(el, ch) {
    if (!el || el.textContent === ch) return;
    el.textContent = ch;
    if (reduce) return;
    el.classList.remove('is-flip');
    void el.offsetWidth; /* reflow → animasyonu yeniden tetikle */
    el.classList.add('is-flip');
  }

  function render() {
    var now = Date.now();
    var sinceMidnight = (((now + IST_OFFSET) % DAY) + DAY) % DAY;
    var remaining = DAY - sinceMidnight; /* İstanbul gece yarısına kalan ms */
    if (remaining < 0) remaining = 0;
    var totalSec = Math.floor(remaining / 1000);
    var hh = Math.floor(totalSec / 3600);
    if (hh > 23) hh = 23; /* gece yarısı anı sınır koruması (24→23) */
    var mm = Math.floor((totalSec % 3600) / 60);
    var ss = totalSec % 60;
    var h = (hh < 10 ? '0' : '') + hh;
    var m = (mm < 10 ? '0' : '') + mm;
    var s = (ss < 10 ? '0' : '') + ss;
    setDigit(cells.h0, h.charAt(0)); setDigit(cells.h1, h.charAt(1));
    setDigit(cells.m0, m.charAt(0)); setDigit(cells.m1, m.charAt(1));
    setDigit(cells.s0, s.charAt(0)); setDigit(cells.s1, s.charAt(1));
  }

  render();
  /* Saniye sınırına hizala, sonra her saniye tik */
  setTimeout(function () {
    render();
    setInterval(render, 1000);
  }, 1000 - (Date.now() % 1000));

  /* Sekme arka plandayken interval boğulur → geri gelince anında düzelt */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) render();
  });
})();


